<template>
  <CModal alignment="center" :visible="show" @close="clearImg">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">新增圖片</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <div
        class="crop-picture d-flex align-items-center justify-content-center flex-column"
      >
        <div
          v-if="image.src"
          class="d-flex justify-content-between align-items-center mb-4 w-100"
        >
          <CButton color="primary" @click="cropOn = !cropOn">裁切模式</CButton>
          <div v-if="cropOn">
            <CButton
              color="secondary"
              variant="ghost"
              class="me-2"
              @click="cropOn = false"
              >取消裁切</CButton
            >
            <CButton color="secondary" variant="ghost" @click="cropImage()"
              >確認裁切</CButton
            >
          </div>
        </div>
        <Cropper
          v-if="cropOn"
          ref="cropper"
          class="cropper"
          :resizeImage="false"
          :src="image.src"
        />
        <img v-else class="preview-img" :src="image.src" />
        <button
          class="upload-picture d-flex mt-4 flex-column align-items-center justify-content-center"
          @click="$refs.file.click()"
        >
          <img class="col-2" src="@/assets/icons/upload.svg" />
          <input
            type="file"
            ref="file"
            @change="uploadImage($event)"
            accept=".jpg, .jpeg, .png "
          />
          <p class="mt-2 fs-5 text-primary">點擊選擇圖片</p>
          <p class="fileTips">可以上傳 JPG , PNG, JPEG，檔案大小要在 3 MB 以下</p>
        </button>
      </div>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="submit">完成</CButton>
      <CButton color="light" @click="clearImg"> 取消 </CButton>
    </CModalFooter>
  </CModal>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { ref } from '@vue/reactivity'
import { onUnmounted } from '@vue/runtime-core'
import useQuestionnaire from '@/composables/useQuestionnaire'
import MsgBox from '@/components/MsgBox.vue'

export default {
  components: {
    Cropper,
    MsgBox,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'image'],
  setup(props, { emit }) {
    const { uploadImage: upload } = useQuestionnaire()
    const image = ref({ src: '', type: 'image/jpg', ext: '' })
    const cropOn = ref(false)
    const cropper = ref(null)
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    const base64ToFile = async (url) => {
      return await fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], `${Date.now()}.${image.value.ext}`, {
            type: image.value.type,
          })
        })
    }

    const clearImg = () => {
      image.value = { src: '', type: 'image/jpg', ext: '' }
      emit('close')
    }
    const cropImage = () => {
      const result = cropper.value.getResult()
      image.value.src = result.canvas.toDataURL(image.value.type)
      cropOn.value = false
    }
    const uploadImage = async (event) => {
      const { files } = event.target

      if (files[0].size / 1024 / 1024 > 3) {
        showMsgBox.value = true
        errorMsg.value = '您所上傳的圖片超過3MB，請重新上傳。'
        return
      }
      if (files && files[0]) {
        if (image.value.src) {
          URL.revokeObjectURL(image.value.src)
        }
        const base64 = await toBase64(files[0])
        image.value = {
          src: base64,
          type: files[0].type,
          ext: files[0].name.split('.')[1],
        }
      }
    }
    onUnmounted(() => {
      if (image.value.src) {
        URL.revokeObjectURL(image.value.src)
      }
    })
    const submit = async () => {
      if (cropOn.value) {
        cropImage()
      }
      const file = await base64ToFile(image.value.src)
      const form = new FormData()
      form.append('image', file)
      const res = await upload(form)
      if (!res.error) {
        emit('image', res.ret.image)
      } else {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      }
      clearImg()
    }
    return {
      image,
      uploadImage,
      cropImage,
      cropper,
      cropOn,
      submit,
      showMsgBox,
      errorMsg,
      errorCode,
      clearImg,
    }
  },
}
</script>

<style lang="scss">
.crop-picture {
  width: 100%;
  min-height: 200px;
  padding: 2%;
}
.upload-picture {
  width: 100%;
  min-height: 200px;
  border: dashed 1px #9ca0a8;
  background: #fff;
  input {
    display: none;
  }
}
.cropper {
  max-height: 200px;
}
.preview-img {
  max-width: 100%;
}
.fileTips {
  font-size: 12px;
  color: rgba($color: #000000, $alpha: 0.5);
}
</style>
